import { connect } from 'react-redux';

// Components:
import SuccessPopup from '../components/SuccessPopup';

// Selectors:
import { getClientEmail } from '../../../store/client/selectors';
import { getCertLink } from '../store/certificate/selectors';
import { getErrorMessage } from '../store/view/selectors';
import {
  getPaymentAmount,
  getOrderIsPaid,
} from '../../../store/payment/selectors';

// Actions:
import { downloadCertificateAction } from '../store/certificate/sagaActions';

const mapStateToProps = (state) => ({
  isShown: getOrderIsPaid(state),
  amount: getPaymentAmount(state),
  clientEmail: getClientEmail(state),
  errorMessage: getErrorMessage(state),
  link: getCertLink(state),
});

const mapDispatchToProps = (dispatch) => ({
  handleFetchCertLink: () => dispatch(downloadCertificateAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPopup);
